import { BellOff, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useNotificationSettings } from "../api/useNotificationSettings";
import { NotificationSettingGroups } from "../components/NotificationSettingGroups";
import { NotificationSettingsSkeleton } from "../components/NotificationSettingsSkeleton";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import EmptyState from "@/components/ui/v2/empty-state";
import { ROUTES } from "@/constants/routes";

export default function NotificationSettingsPage() {
  const { t } = useTranslation();
  const { data, isPending, refetch } = useNotificationSettings();

  const renderContent = () => {
    if (isPending) return <NotificationSettingsSkeleton />;

    if (!data) {
      return (
        <div data-testid="notification-settings-error">
          <EmptyState
            icon={TriangleAlert}
            title={t("notificationSettings.errorTitle")}
            description={t("notificationSettings.errorDescription")}
            action={{ label: t("common.retry"), onClick: () => void refetch() }}
          />
        </div>
      );
    }

    if (data.settings.length === 0) {
      return (
        <div data-testid="notification-settings-empty">
          <EmptyState
            icon={BellOff}
            title={t("notificationSettings.emptyTitle")}
            description={t("notificationSettings.emptyDescription")}
          />
        </div>
      );
    }

    return <NotificationSettingGroups settings={data.settings} />;
  };

  return (
    <ModernPageLayout
      title={t("notificationSettings.title")}
      subtitle={t("notificationSettings.subtitle")}
      backbutton={{ label: t("notifications.title"), href: `/${ROUTES.notifications}` }}
    >
      <div data-testid="notification-settings-page" className="w-full">
        {renderContent()}
      </div>
    </ModernPageLayout>
  );
}
